import * as _ from 'lodash'
import {AccountService} from "../../core/services/AccountService"
import {CategoryService} from "../../core/services/CategoryService"
export class RegisterPageComponent implements ng.IComponentOptions {
    public controller: any = RegisterController;
    public template: string = /*html*/ `
      <div class="container container-fluid">
        <div class="row">
        <div class="col-md-3">
          <div class="panel panel-default">
          <div class="panel-heading">
          <h3 class="panel-title"><i class="fa fa-user-circle fa-fw"></i>&nbsp;Already Registered? </h3>
          </div>
          <div class="list-group">
            <div class="list-group-item">Already registered with us? If so, click the button below to login to our client area from where you can manage your account.</div>
              <a class="list-group-item" href="#/login"><i class="fa fa-user fa-fw"></i>&nbsp;Login</a>
              <a class="list-group-item" href="#/reset-password"><i class="fa fa-asterisk fa-fw"></i>&nbsp;Forgot Password</a>
            </div>
          </div>
        </div>
        <div class="col-md-9">
        <div ng-hide="$ctrl.regSuccess">
        <h2>Register</h2>
        <uib-tabset active="$ctrl.active">
        <uib-tab index="0" heading="Personal" select="$ctrl.resetForm()">
        <p class="text-highlight">Personal account allow you to explore, preview and download datasets.</p>
        <p class="text-danger text-center text-small" ng-show="$ctrl.error.duplicated">This Email has been used!</p>
        <p class="text-danger text-center text-small" ng-show="$ctrl.error.required">All fields are required!</p>
        <form name="$ctrl.regPsForm" class="form-horizontal form-ckan" ng-submit="$ctrl.register()">
        <div class="form-group">
        <label for="name" class="col-sm-5 control-label">Full Name <span class="text-danger">*</span></label>
        <div class="col-sm-7">
          <input type="text" class="form-control" ng-model="$ctrl.form.fullname" id="name" placeholder="Full Name" required>
        </div>
        </div>
        <div class="form-group">
        <label for="inputEmail" class="col-sm-5 control-label">Email <span class="text-danger">*</span></label>
        <div class="col-sm-7">
          <input type="email" name="email" class="form-control" ng-model="$ctrl.form.email" ng-pattern="$ctrl.emailPattern" id="inputEmail" placeholder="Email" required>
          <span class="text-danger text-small" ng-show="regPsForm.email.$error.pattern">Wrong Email Format</span>
        </div>
        </div>
        <div class="form-group">
        <label for="contact" class="col-sm-5 control-label">Contact No <span class="text-danger">*</span></label>
        <div class="col-sm-7">
        <input type="text" class="form-control" ng-model="$ctrl.form.contact" id="contact" placeholder="Contact No" required>
        </div>
        </div>
        <div class="form-group">
        <label for="userType" class="col-sm-5 control-label">Type of User <span class="text-danger">*</span></label>
        <div class="col-sm-7">
        <ui-select ng-model="$ctrl.form.category" required>
        <ui-select-match placeholder="Select a User Type">
        <span ng-bind="$select.selected.name"></span>
        </ui-select-match>
        <ui-select-choices repeat="item.name as item in ($ctrl.userType | filter: $select.search)">
        <span ng-bind="item.name"></span>
        </ui-select-choices>
        </ui-select>
        </div>
        </div>
        <div class="form-group">
        <label for="purpose" class="col-sm-5 control-label">Purpose <span class="text-danger">*</span></label>
        <div class="col-sm-7">
        <ui-select ng-model="$ctrl.form.purpose" required>
        <ui-select-match placeholder="Select a Purpose">
        <span ng-bind="$select.selected.name"></span>
        </ui-select-match>
        <ui-select-choices repeat="item.name as item in ($ctrl.purposes | filter: $select.search)">
        <span ng-bind="item.name"></span>
        </ui-select-choices>
        </ui-select>
        </div>
        </div>
        </form>
        </uib-tab>
        <uib-tab index="1" heading="Organisation" select="$ctrl.resetForm()">
        <p class="text-highlight">Register as organisation account if you are represent an organisation body. Your account will require for verification before you can login.</p>
        <p class="text-danger text-center text-small" ng-show="$ctrl.error.duplicated">This Email has been used!</p>
        <p class="text-danger text-center text-small" ng-show="$ctrl.error.required">All fields are required!</p>
        <form name="$ctrl.regOrgForm" class="form-horizontal form-ckan" ng-submit="$ctrl.register()">
        <div class="form-group">
        <label for="name" class="col-sm-5 control-label">Full Name <span class="text-danger">*</span></label>
        <div class="col-sm-7">
          <input type="text" class="form-control" ng-model="$ctrl.form.fullname" id="name" placeholder="Full Name" required>
        </div>
        </div>
        <div class="form-group">
        <label for="inputEmail" class="col-sm-5 control-label">Email <span class="text-danger">*</span></label>
        <div class="col-sm-7">
          <input name="email" type="email" class="form-control" ng-model="$ctrl.form.email" ng-pattern="$ctrl.emailPattern" id="inputEmail" placeholder="Email" required>
          <span class="text-warning" ng-show="regOrgForm.email.$error.pattern">Wrong Email Format</span>
          <div class="text-warning">Official email address is required</div>
        </div>
        </div>
        <div class="form-group">
        <label for="contact" class="col-sm-5 control-label">Contact No <span class="text-danger">*</span></label>
        <div class="col-sm-7">
        <input type="text" class="form-control" ng-model="$ctrl.form.contact" id="contact" placeholder="Contact No" required>
        </div>
        </div>
        <div class="form-group">
        <label for="orgName" class="col-sm-5 control-label">Organisation Name <span class="text-danger">*</span></label>
        <div class="col-sm-7">
        <input type="text" class="form-control" id="orgName" ng-model="$ctrl.form.organization.name" placeholder="Organisation Name" required>
        </div>
        </div>
        <div class="form-group">
        <label for="orgType" class="col-sm-5 control-label">Type of Organisation <span class="text-danger">*</span></label>
        <div class="col-sm-7">
        <ui-select ng-model="$ctrl.form.organization.org_type" required>
        <ui-select-match placeholder="Select a Organisation Type">
        <span ng-bind="$select.selected.name"></span>
        </ui-select-match>
        <ui-select-choices repeat="item.name as item in ($ctrl.orgType | filter: $select.search)">
        <span ng-bind="item.name"></span>
        </ui-select-choices>
        </ui-select>
        </div>
        </div>
        <div class="form-group">
        <label for="purpose" class="col-sm-5 control-label">Purpose <span class="text-danger">*</span></label>
        <div class="col-sm-7">
        <ui-select ng-model="$ctrl.form.purpose" required>
        <ui-select-match placeholder="Select a Purpose">
        <span ng-bind="$select.selected.name"></span>
        </ui-select-match>
        <ui-select-choices repeat="item.name as item in ($ctrl.purposes | filter: $select.search)">
        <span ng-bind="item.name"></span>
        </ui-select-choices>
        </ui-select>
        </div>
        </div>
        </form>
        </uib-tab>
        </uib-tabset>
        <div class="form-horizontal form-ckan">
        <div class="form-group">
          <label for="purpose" class="col-sm-5 control-label">Password <span class="text-danger">*</span></label>
          <div class="col-sm-7">
            <input type="password" class="form-control"  ng-model="$ctrl.form.password" />
          </div>
        </div>
        <div class="form-group">
          <label for="purpose" class="col-sm-5 control-label">Confirm Password <span class="text-danger">*</span></label>
          <div class="col-sm-7">
            <input type="password" class="form-control" ng-model="$ctrl.form.confirm_password" ng-change="$ctrl.verifyPassword()" />
          </div>
          <div class="text-warning" ng-show="$ctrl.error.password">Password not match</div>
          <div class="text-warning" ng-show="$ctrl.error.password_quality">{{$ctrl.error.password_quality}}</div>
        </div>
        <div class="checkbox">
          <label>
            <input type="checkbox" ng-model="$ctrl.form.subscription"> Notify me when there are new published statistics
          </label>
        </div>
        </div>
        <div class="control-panel">
        <button class="btn btn-primary pull-right" ng-click="$ctrl.register()" ng-disabled="$ctrl.submitting">Create Account</button>
        </div>
        </div>
        <div ng-show="$ctrl.regSuccess">
          <h3>Thank you for registering with us.</h3>
          <p>A confirmation email has been sent to <strong>{{ $ctrl.regEmail }}</strong><p>
          <a class="btn btn-primary" href="#/login">Login Now</a>
        </div>
        </div>
        </div>
    </div>`;
}
export class RegisterController {
    public static $inject: Array<string> = ["AccountService", "CategoryService", "$anchorScroll"];
    public tree: Array<Object>;
    public userType: Array<String>;
    public orgType: Array<String>;
    public purposes: Array<String>;
    public submitting: boolean;
    public regSuccess: boolean;
    public regEmail: string;
    public form: any;
    public error: any;
    public emailPattern: RegExp;
    public active: number;
    public regPsForm: any;
    public regOrgForm: any;

    constructor(private account: AccountService, private category: CategoryService, private $anchorScroll: ng.IAnchorScrollService) {
      category.query("usertype").then((d:any) => {
        this.userType = d;
      })
      category.query("orgtype").then((d:any) => {
        this.orgType = d;
      })
      category.query("purpose").then((d:any) => {
        this.purposes = d;
      })
      this.error = {duplicated: false}
      this.emailPattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    }

    public $onInit() {
      this.$anchorScroll();
    }

    public register() {
      if(this.active == 0 && this.regPsForm.$invalid || this.active == 1 && this.regOrgForm.$invalid) {
        this.error.required = true;
        return
      }
      else if (this.form.password !== this.form.confirm_password) {
        this.error.password = true
        return
      }
      else
        this.error.required  = false;
      if (this.form.subscription) {
        this.form.subscription = ['published']
      }
      if(this.form.email) {
        this.submitting = true;
        this.account.register(this.form)
        .then(d => {
          this.submitting = false;
          this.regSuccess = true;
          this.regEmail = d.data.email;
        })
        .catch(err => {
          this.submitting = false;
          this.regSuccess = false;
          if(err.data.code && err.data.code == '11000'){
            this.error.duplicated = true;
          }
          else if (_.get(err, 'data.data.password[0]', null)) {
            this.error = {
              ...this.error,
              password_quality: _.get(err, 'data.data.password[0]', null)
            }
          }
        });
      }
    }

    public resetForm() {
      this.form = {};
    }

    public verifyPassword() {
      if (this.form.password !== this.form.confirm_password) {
        this.error = {
          ...this.error,
          password: true
        }
      }
      else {
        this.error = {
          ...this.error,
          password: false
        }
      }
    }

}
